import * as React from 'react';
import icons from '../../../../../../../CheckoutAdditionalService/icons';
import CheckoutAdditionalService from '../../../../../../../CheckoutAdditionalService';
import { useTheme } from '../../../../../../../theme';
var Stub = function (props) {
    var theme = useTheme('Exchange').Stub;
    return (React.createElement(CheckoutAdditionalService, { className: theme.stub, icon: icons.mealIcon, header: '', isSelected: false, description: '', addClick: function () { return null; } }));
};
export default Stub;
